import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useAuthStore } from '~/stores/auth';

function hasRequiredAccess(
  hasUserPermission: (permission: string) => boolean,
  meta: {
    requiredPermission?: string;
    requiredPermissions?: string[];
  }
): boolean {
  if (
    Array.isArray(meta.requiredPermissions) &&
    meta.requiredPermissions.length > 0
  ) {
    return meta.requiredPermissions.some(hasUserPermission);
  }

  if (!meta.requiredPermission) {
    return true;
  }

  return hasUserPermission(meta.requiredPermission);
}

export default defineNuxtRouteMiddleware(to => {
  const meta = to.meta as {
    requiredPermission?: string;
    requiredPermissions?: string[];
  };

  if (!meta.requiredPermission && !meta.requiredPermissions?.length) {
    return;
  }

  const authStore = useAuthStore();
  if (!hasRequiredAccess(authStore.hasUserPermission, meta)) {
    return navigateTo('/profile');
  }
});
